import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortByPricePipe } from './sort-by-price.pipe';

@NgModule({
  declarations: [SortByPricePipe],
  imports: [CommonModule],
  exports: [SortByPricePipe],
})
export class PipesModule {}
